import SearchClientProfileEntriesForm from './SearchClientProfileEntriesForm';

export default SearchClientProfileEntriesForm;


// WEBPACK FOOTER //
// ./src/features/client-profile/components/searching/search-form/index.js